export default "__VITE_ASSET__BgKDKQh___"